import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="bg-background text-foreground flex h-full min-h-[calc(100dvh-theme(spacing.16))] items-center justify-center p-6">
      <div className="mx-auto w-full max-w-lg space-y-4 text-center">
        <div className="text-muted-foreground text-sm">404</div>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="text-muted-foreground text-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex justify-center gap-2 pt-2">
          <Button
            onClick={() => {
              navigate(-1);
            }}
            type="button"
            variant="outline"
          >
            Go back
          </Button>
          <Button
            onClick={() => {
              navigate('/firm/home');
            }}
            type="button"
          >
            Home
          </Button>
        </div>
      </div>
    </div>
  );
}
